export default "__VITE_ASSET__CLnxMEeP__"